import { labelsEn } from './labels-en';
export const labelsDe = {
  ...labelsEn,
  title: 'Etiketten & Kennzeichnung',
  subtitle: 'Versionierte, mehrsprachige Etiketten aus freigegebenen Produktdaten.',
  active: 'Aktiv',
  inactive: 'Inaktiv',
  autoReleased: 'Neueste freigegebene Version',
  help: { open: 'Etikettenhilfe öffnen' },
  tabs: {
    templates: 'Vorlagen',
    formats: 'Formate',
    prints: 'Druckhistorie',
    design: 'Gestaltung',
    previewPrint: 'Vorschau & Druck',
  },
  templates: {
    title: 'Etikettenvorlagen',
    description:
      'Der Label-Modus verwendet den zentralen PDF-Designer und friert jeden freigegebenen Stand ein.',
    create: 'Neue Vorlage',
    createDescription:
      'Beginnen Sie mit einem validierten physischen Format und einem produktionsfähigen Grundlayout.',
  },
  formats: {
    title: 'Etikettenformate',
    description: 'Blätter, Rollen, Raster, Ränder und Abstände werden in Millimetern gepflegt.',
    create: 'Neues Format',
    edit: 'Format bearbeiten',
  },
  prints: {
    title: 'Druckhistorie',
    description: 'Unveränderliche Test-, Produktions- und Nachdrucknachweise im DMS.',
  },
  designer: {
    subtitle: 'Vorlagenversion {{version}}',
    elements: 'Elemente',
    canvas: 'Etikettenfläche',
    inspector: 'Eigenschaften',
    selectElement: 'Wählen Sie ein Element zur Bearbeitung.',
  },
  preview: {
    title: 'Datensnapshot',
    description:
      'Wählen Sie echte ERP-Quelldaten. Der Server validiert und rendert denselben Snapshot wie beim Druck.',
    legalTitle: 'Prüfung erforderlich',
    legalWarning:
      'Deklarationen und rechtliche Kennzeichnungsinhalte müssen vor verbindlicher Nutzung durch qualifizierte Personen geprüft und ausdrücklich freigegeben werden.',
    pdf: 'Serverseitige PDF-Vorschau',
    empty: 'Wählen Sie Daten und erzeugen Sie eine Vorschau.',
  },
  fields: {
    ...labelsEn.fields,
    name: 'Name',
    description: 'Beschreibung',
    mediaType: 'Medientyp',
    active: 'Aktiv',
    pageWidthMm: 'Seitenbreite (mm)',
    pageHeightMm: 'Seitenhöhe (mm)',
    labelWidthMm: 'Etikettenbreite (mm)',
    labelHeightMm: 'Etikettenhöhe (mm)',
    columns: 'Spalten',
    rows: 'Zeilen',
    marginLeftMm: 'Linker Rand (mm)',
    marginTopMm: 'Oberer Rand (mm)',
    horizontalGapMm: 'Horizontaler Abstand (mm)',
    verticalGapMm: 'Vertikaler Abstand (mm)',
    format: 'Format',
    text: 'Text',
    dynamicField: 'Dynamisches Datenfeld',
    analysisParameter: 'Analyseparameter-Schlüssel',
    symbology: 'Barcode-Symbologie',
    valueTemplate: 'Wertvorlage',
    gs1Segments: 'GS1-Segmente',
    gs1Hint: 'Format: AI:Quelle:feste Länge, z. B. 01:product.number:14, 10:batch.number',
    xMm: 'X (mm)',
    yMm: 'Y (mm)',
    widthMm: 'Breite (mm)',
    heightMm: 'Höhe (mm)',
    rotation: 'Drehung',
    fontSize: 'Schriftgröße (pt)',
    bold: 'Fett',
    languages: 'Sprachen',
    product: 'Artikel',
    batch: 'Charge',
    productionOrder: 'Produktionsauftrag',
    declaration: 'Deklaration',
    analysis: 'Analyse / Nährwerte',
    quantity: 'Menge',
    unit: 'Einheit',
    copies: 'Exemplare',
    reason: 'Begründung',
    note: 'Prüfvermerk',
  },
  columns: {
    name: 'Name',
    version: 'Version',
    format: 'Format',
    status: 'Status',
    updated: 'Geändert',
    page: 'Seite',
    grid: 'Raster',
    number: 'Drucknummer',
    product: 'Artikel / Charge',
    template: 'Vorlage',
    kind: 'Art',
    created: 'Erstellt',
    actions: 'Aktionen',
  },
  media: { SHEET: 'Bogen', ROLL: 'Rolle' },
  versionStatuses: {
    DRAFT: 'Entwurf',
    IN_REVIEW: 'In Prüfung',
    APPROVED: 'Freigegeben',
    ARCHIVED: 'Archiviert',
  },
  printKinds: { TEST: 'Testdruck', PRODUCTION: 'Produktionsdruck', REPRINT: 'Nachdruck' },
  printStatuses: { PENDING: 'In Verarbeitung', READY: 'Bereit', FAILED: 'Fehlgeschlagen' },
  elementTypes: {
    TEXT: 'Text',
    DYNAMIC_TEXT: 'Dynamischer Text',
    BARCODE: 'Barcode',
    QR_CODE: 'QR-Code',
    LINE: 'Linie',
    BOX: 'Rahmen',
  },
  dynamicFields: {
    product: {
      number: 'Artikelnummer',
      ean: 'EAN / GTIN',
      name: 'Artikelbezeichnung',
      externalName: 'Externe Bezeichnung',
      declarationName: 'Deklarationsbezeichnung',
    },
    declaration: {
      productName: 'Verkehrsbezeichnung',
      ingredients: 'Zutatenliste',
      allergens: 'Allergene',
      additives: 'Zusatzstoffe',
      warnings: 'Warnhinweise',
    },
    nutrition: { summary: 'Nährwertübersicht' },
    analysis: { value: 'Analysewert' },
    batch: {
      number: 'Chargennummer',
      bestBeforeDate: 'Mindesthaltbarkeitsdatum',
      expiryDate: 'Verbrauchsdatum',
      productionDate: 'Produktionsdatum',
    },
    productionOrder: { number: 'Produktionsauftragsnummer' },
    quantity: { value: 'Menge', unit: 'Einheit' },
    storage: { instructions: 'Lagerhinweise' },
  },
  actions: {
    addElement: 'Element hinzufügen',
    moveUp: 'Nach oben',
    moveDown: 'Nach unten',
    newVersion: 'Neue Version',
    submit: 'Einreichen',
    approve: 'Freigeben',
    archive: 'Archivieren',
    preview: 'Vorschau',
    testPrint: 'Testdruck',
    productionPrint: 'Produktionsdruck',
    download: 'PDF öffnen',
    reprint: 'Nachdrucken',
  },
  transition: {
    submit: {
      title: 'Zur Prüfung einreichen',
      description: 'Während der Prüfung ist das Layout für Bearbeitung gesperrt.',
    },
    approve: {
      title: 'Etikett freigeben',
      description: 'Die Vier-Augen-Freigabe friert die Version für Produktionsdrucke ein.',
    },
    archive: {
      title: 'Version archivieren',
      description: 'Archivierte Versionen und Drucknachweise bleiben unveränderlich.',
    },
  },
  copy: {
    title: 'Neue Version erstellen',
    description: 'Die gewählte Version wird in einen neuen bearbeitbaren Entwurf kopiert.',
  },
  reprint: {
    title: 'Begründeter Nachdruck',
    description:
      'Historische Version und Datensnapshot werden exakt wiederverwendet. Begründen Sie den erneuten Druck.',
  },
  messages: {
    invalid: 'Bitte prüfen Sie die Eingaben.',
    formatSaved: 'Das Format wurde gespeichert.',
    templateCreated: 'Die Vorlage wurde angelegt.',
    saved: 'Der Entwurf wurde gespeichert.',
    submit: 'Die Version wurde eingereicht.',
    approve: 'Die Version wurde freigegeben.',
    archive: 'Die Version wurde archiviert.',
    versionCreated: 'Eine neue Entwurfsversion wurde erstellt.',
    printCreated: 'Druck {{number}} wurde erzeugt.',
    reprintCreated: 'Der Nachdruck wurde protokolliert.',
    productRequired: 'Wählen Sie zuerst einen Artikel.',
    loadFailed: 'Die Etikettenvorlage konnte nicht geladen werden.',
  },
} as const;
